export const translateLabel = (label, locale) => {
  if (typeof label === 'string') {
    return label;
  }
  return label?.[locale];
};
